import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage

// Import all reducers
import workflowReducer from "./workflowContent";
import loginStore from "./authContent";
import authReducer from "../store/auth-store";
import treeStructureReducer from "./treeStructure";
import submissionTreeReducer from "./SubmissionTree";
import expansionTreeReducer from "./Expanded";
import allocationReducer from "./allocationType";
import applicationReducer from "./applicationType";
import formGroupOrFormReducer from "./FormGroup";
import normalTaskReducer from "./NormalTaskContent";
import responseTreeStructureReducer from "./TreeStructureSubmission";
import filterDateReducer from "./tableFilter";
import dashboardTableFilterDataReducer from "./DashboardTableFilter";
import sidebarReducer from "./sidebarSlice";
import filterDataReducer from './SubmissionFilterData'; 
import paginationReducer from "./SubmissionPagination";
import themeReducer from "./themeSlice";
import chatbotReducer from "./chatbotSlice";
// Combine all reducers
const rootReducer = combineReducers({
  login: authReducer,
  workflow: workflowReducer,
  treeData: treeStructureReducer,
  submissionData: submissionTreeReducer,
  expansionData: expansionTreeReducer,
  allocation: allocationReducer,
  formGroupOrForm: formGroupOrFormReducer,
  normalTask: normalTaskReducer,
  submissionTreeData: responseTreeStructureReducer,
  application: applicationReducer,
  filterData: filterDateReducer,
  dashboardFilterData: dashboardTableFilterDataReducer,
  sidebar: sidebarReducer, // Sidebar reducer is part of the combined reducers
  submissionFilterData: filterDataReducer,
  submissionPaginationData: paginationReducer,
  theme: themeReducer, //theme reducer
  chatbot: chatbotReducer,
});

// Persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["sidebar","submissionFilterData",'submissionPaginationData', "theme"], // Specify reducers to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable checks for non-serializable values (required for redux-persist)
    }),
});

// Persistor
export const persistor = persistStore(store);
